<template>
  <div>
    <v-list-item
      v-for="(link, i) in links"
      :key="i"
      :to="link.to"
      class="v-list-item"
    >
      <v-list-item-action>
        <IconCustom :name="link.icon" />
      </v-list-item-action>
      <v-list-item-title>{{ link.text }}</v-list-item-title>
    </v-list-item>
  </div>
</template>

<script>
import IconCustom from "@/components/helper/IconCustom.vue";

export default {
  components: {
    IconCustom
  },
  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
